import { mergeOverrides } from 'baseui';
import React from 'react';
import { useStyletron } from '../../Themes';
import { borderColor, borderWidth, borderRadius } from '../../Utilities/utils/Theming';
import { ISmartProps } from './types';
import { View } from './view';

export type FormGroupProps = Omit<ISmartProps, 'css'>;

export const FormControl = View;

export const FormControlFieldset = (props: FormGroupProps) => {
	const { overrides = {}, className, ...rest } = props;
	const [css] = useStyletron();
	return (
		<fieldset className={`${className} ${css({
			...borderColor("var(--epods--color-border-light)"),
			...borderWidth("var(--epods--border-width)"),
			...borderRadius("var(--epods--border-radius)"),
			minWidth: "0",
		})}`}>
			<View
				{...rest}
				overrides={mergeOverrides(
					// @ts-ignore
					overrides,
					{
						Label: {
							props: {
								$as: 'legend',
							},
						},
						ControlContainer: {
							style: {
								display: 'inline-block',
							},
						},
					},
				)}
			/>
		</fieldset>
	);
};
